<template>

  <div>

    <div class="bannerWrap">
      <my-header> </my-header>
    </div>
    <div class="webbg">
      <div class="web">
        <div class="producttitle">
          选择颜色 <span>首页 > 产品定制</span>
        </div>

        <div class="productschedule">
          <a href="javascript:;"
             class="cur">型号选择</a><a href="javascript:;"
             class="cur">选择颜色</a><a href="javascript:;"
             class="cur">个性设计定制</a><a href="#">个人资料</a><a href="javascript:;">确认购买</a>
        </div>

        <div class="productsbox clearfl">

          <div class="product-container">

            <div class="productright">

              <!--为了适应响应式 所以复制结构-->
              <div class="m-productmodel-container">

                <div class="m-productmodel-scroll">
                  <div class="productmodel clearfl">
                    <!--左边耳机-->
                    <div class="productmodelleft"
                         @click='changeselectleft()'>
                      <!--自定义上传-->
                      <div class="headsetcustommade">
                        <div class="custommade leftcustomize"
                             v-bind:style="{backgroundImage:'url('+CustomUplod.leftimg+')',      
                            width:CustomUplod.Lwidth + '%',
                            height:CustomUplod.Lheight + '%',
                            left:CustomUplod.Lleft + '%',
                            top:CustomUplod.Ltop + '%',
                            transform:'rotate('+CustomUplod.Lrotate+'deg) scale('+CustomUplod.Lscale+')'
                      }">

                        </div>
                        <div class="headsetsmalllogo"></div>
                      </div>
                      <!--耳机线-->
                      <div class="headsetline" v-bind:style="{backgroundImage:'url(' + httpurl + SelectDesign.Wleftimg + ')'}"></div>
                      <!--耳机壳-->
                      <div class="headsetmold"
                           v-bind:style="{backgroundImage:'url(' + httpurl + SelectDesign.Krightimg + ')'}"></div>
                      <!--耳机壳加金箔粉-->
                      <div class="headsetgold"
                           v-bind:style="{backgroundImage:'url(' + httpurl + SelectDesign.KADDleftimg + ')'}"></div>
                      <!--耳机模-->
                      <div class="headsetcover"
                           v-bind:style="{backgroundImage:'url(' + httpurl + SelectDesign.rightimg + ')'}"></div>
                      <!--耳机模加金箔粉-->
                      <div class="headsetother"
                           v-bind:style="{backgroundImage:'url(' + httpurl + SelectDesign.addleftimg + ')'}"></div>
                      <!--耳机logo-->
                      <div class="headsetBiglogo"
                           v-bind:style="{backgroundImage:'url(' + httpurl + DesignMake.leftlogoimg + ')'}"></div>

                    </div>
                    <!--左边耳机-->

                    <!--右边耳机-->
                    <div class="productmodelright"
                         @click='changeselectright()'>
                      <!--自定义上传-->
                      <div class="headsetcustommade">
                        <div class="custommade rightcustomize"
                             v-bind:style="{backgroundImage:'url('+CustomUplod.rightimg+')',      
                            width:CustomUplod.Rwidth + '%',
                            height:CustomUplod.Rheight + '%',
                            left:CustomUplod.Rleft + '%',
                            top:CustomUplod.Rtop + '%',
                            transform:'rotate('+CustomUplod.Rrotate+'deg) scale('+CustomUplod.Rscale+')'
                      }"></div>
                        <div class="headsetsmalllogo"></div>
                      </div>
                      <!--耳机线-->
                      <div class="headsetline" v-bind:style="{backgroundImage:'url(' + httpurl + SelectDesign.Wrightimg + ')'}"></div>
                      <!--耳机壳-->
                      <div class="headsetmold"
                           v-bind:style="{backgroundImage:'url(' + httpurl + SelectDesign.Kleftimg + ')'}"> </div>
                      <!--耳机壳加金箔粉-->
                      <div class="headsetgold"
                           v-bind:style="{backgroundImage:'url(' + httpurl + SelectDesign.KADDrightimg + ')'}"></div>
                      <!--耳机模-->
                      <div class="headsetcover"
                           v-bind:style="{backgroundImage:'url(' + httpurl + SelectDesign.leftimg + ')'}"></div>
                      <!--耳机模加金箔粉-->
                      <div class="headsetother"
                           v-bind:style="{backgroundImage:'url(' + httpurl + SelectDesign.addrightimg + ')'}">></div>
                      <!--耳机logo-->
                      <div class="headsetBiglogo"
                           v-bind:style="{backgroundImage:'url(' + httpurl + DesignMake.rightlogoimg + ')'}"></div>
                    </div>
                    <!--右边耳机-->
                  </div>
                </div>
                <div class="selectheadset"
                     rel="0">
                  <span class="scrollbar"
                        v-bind:style="'left:'+ changeselect + '%'"></span>
                  <dl>
                    <dd class="selectLeft"
                        @click='changeselectleft()'>Left</dd>
                    <dt class="selectPair"
                        @click='changeselectmiddle()'></dt>
                    <dd class="selectRight"
                        @click='changeselectright()'>Right</dd>
                  </dl>
                </div>
                <p class="design-fonts">木纹和钟表仅供参考，实际是不一样的，钟表面板上的logo(qdc)默认是刻在壳体上的.</p>
              </div>

              <div class="customize-wrapper">

                <div class="customize">
                  <h3>自定图形</h3>
                  <div class="customizeUpload">
                    <h4 class="leftUpload"
                        v-for="(item, index) in UploadName.slice(0,1)"
                        :key="index"
                        @click='uploadLOGO(item.id)'>{{item.name}}</h4>
                    <input type="file"
                           ref="fileInput"
                           accept="image/*"
                           @change="getFile"
                           style="display: none" />

                    <!-- <input type="file"
                           value="webimages/index_03.jpg" /> -->
                    <dl v-show='leftUploadVisable'
                        @click="changeleft">
                      <dd class="clearfl">
                        <div class="customizename">左右</div>
                        <div class="sliderstyle">
                          <vue-slider v-model="change.Lzy"
                                      :min="1"
                                      :max="100"
                                      :interval="0.01"
                                      :contained="true">
                          </vue-slider>
                        </div>

                      </dd>
                      <dd class="clearfl">
                        <div class="customizename">上下</div>
                        <div class="sliderstyle">
                          <vue-slider v-model="change.Lsx"
                                      :min="1"
                                      :max="100"
                                      :interval="0.01"
                                      :contained="true">
                          </vue-slider>
                        </div>
                      </dd>
                      <dd class="clearfl">
                        <div class="customizename">大小</div>
                        <div class="sliderstyle">
                          <vue-slider v-model="change.Ldx"
                                      :min="0.1"
                                      :max="10"
                                      :interval="0.01"
                                      :contained="true">
                          </vue-slider>
                        </div>
                      </dd>
                      <dd class="clearfl">
                        <div class="customizename">旋转</div>
                        <div class="sliderstyle">
                          <vue-slider v-model="change.Lxz"
                                      :min="0"
                                      :max="360"
                                      :interval="0.01"
                                      :contained="true">
                          </vue-slider>
                        </div>
                      </dd>
                      <dd class="clearfl"
                          style="display:none;">
                        <div class="customizename"></div>
                        <div class=""
                             style="text-align:center; color:#fff;"><span class="left_logo_bg_jin cur_hand">金色Logo</span> &nbsp;&nbsp; <span class="left_logo_bg_yin cur_hand">银色Logo</span></div>
                      </dd>
                    </dl>
                  </div>

                  <div class="customizeUpload">
                    <h4 class="leftUpload"
                        v-for="(item, index) in UploadName.slice(1)"
                        :key="index"
                        @click='uploadLOGO(item.id)'>{{item.name}}</h4>
                    <input type="file"
                           value="webimages/index_03.jpg" />
                    <dl v-show='rightUploadVisable'
                        @click="changeright">
                      <dd class="clearfl">
                        <div class="customizename">左右</div>
                        <div class="sliderstyle">
                          <vue-slider v-model="change.Rzy"
                                      :min="1"
                                      :max="100"
                                      :interval="0.01"
                                      :contained="true">
                          </vue-slider>
                        </div>
                      </dd>
                      <dd class="clearfl">
                        <div class="customizename">上下</div>
                        <div class="sliderstyle">
                          <vue-slider v-model="change.Rsx"
                                      :min="1"
                                      :max="100"
                                      :interval="0.01"
                                      :contained="true">
                          </vue-slider>
                        </div>
                      </dd>
                      <dd class="clearfl">
                        <div class="customizename">大小</div>
                        <div class="sliderstyle">
                          <vue-slider v-model="change.Rdx"
                                       :min="0.1"
                                      :max="10"
                                      :interval="0.01"
                                      :contained="true">
                          </vue-slider>
                        </div>
                      </dd>
                      <dd class="clearfl">
                        <div class="customizename">旋转</div>
                        <div class="sliderstyle">
                          <vue-slider v-model="change.Rxz"
                                      :min="0"
                                      :max="360"
                                      :interval="0.01"
                                      :contained="true">
                          </vue-slider>
                        </div>
                      </dd>
                      <dd class="clearfl"
                          style="display:none;">
                        <div class="customizename"></div>
                        <div class=""
                             style="text-align:center; color:#fff;">
                          <span class="right_logo_bg_jin cur_hand">金色Logo</span> &nbsp;&nbsp;
                          <span class="right_logo_bg_yin cur_hand">银色Logo</span></div>
                      </dd>
                    </dl>
                  </div>

                </div>

                <div class="customize">
                  <h3>Logo样式</h3>
                  <div class="Logostyle">
                    <a v-for="(item,index) in LogoList "
                       :key="index"
                       @click='handlelogostyle(index,item)'
                       :class="{'cur':index==logostylenumber}">{{item.name}}</a>
                  </div>
                </div>

                <div class="customize"
                     v-if="isshowlogocolor">
                  <h3>Logo颜色</h3>
                  <div class="LogostyleColour">

                    <div style="color:#ffffff; text-align:center; margin-top:20px">
                      <span v-if="logostylenumber==-1"> 请选择LOGO样式 </span>
                      <a v-for="(item,index) in LogoList[logostylenumber].list"
                         :key="item.id"
                         v-show="logostylenumber!=-1"
                         @click='handlelogoColor(index,item)'
                         :class="{'cur':index===logoColornumber}">{{item.name}}</a>
                      <!-- <a v-for="(item,index) in LogoColorList2 "
                         :key="item.id"
                         v-show="logostylenumber==1"
                         @click='handlelogoColor(index,item)'
                         :class="{'cur':index===logoColornumber}">{{item.name}}</a> -->
                    </div>

                  </div>
                </div>

              </div>
              <div class="customizeNext">
                <a @click='back()'>上一步</a>
                <a class="cur"
                   @click='message()'>下一步</a>
              </div>

            </div>

            <div class="productleft">

              <div class="productmodel-container">

                <div class="productmodel clearfl">
                  <!--左边耳机-->
                  <div class="productmodelleft"
                       @click='changeselectleft()'>
                    <!--自定义上传-->
                    <div class="headsetcustommade">
                      <div class="custommade leftcustomize"
                           v-bind:style="{backgroundImage:'url('+CustomUplod.leftimg+')',      
                            width:CustomUplod.Lwidth + '%',
                            height:CustomUplod.Lheight + '%',
                            left:CustomUplod.Lleft + '%',
                            top:CustomUplod.Ltop + '%',
                            transform:'rotate('+CustomUplod.Lrotate+'deg) scale('+CustomUplod.Lscale+')'
                      }">

                      </div>
                      <div class="headsetsmalllogo"></div>
                    </div>
                    <!--耳机线-->
                    <div class="headsetline" v-bind:style="{backgroundImage:'url(' + httpurl + SelectDesign.Wleftimg + ')'}"></div>
                    <!--耳机壳-->
                    <div class="headsetmold"
                         v-bind:style="{backgroundImage:'url(' + httpurl + SelectDesign.Krightimg + ')'}"></div>
                    <!--耳机壳加金箔粉-->
                    <div class="headsetgold"
                         v-bind:style="{backgroundImage:'url(' + httpurl + SelectDesign.KADDleftimg + ')'}"></div>
                    <!--耳机模-->
                    <div class="headsetcover"
                         v-bind:style="{backgroundImage:'url(' + httpurl + SelectDesign.rightimg + ')'}"></div>
                    <!--耳机模加金箔粉-->
                    <div class="headsetother"
                         v-bind:style="{backgroundImage:'url(' + httpurl + SelectDesign.addleftimg + ')'}"></div>
                    <!--耳机logo-->
                    <div class="headsetBiglogo"
                         v-bind:style="{backgroundImage:'url(' + httpurl + DesignMake.leftlogoimg + ')'}"></div>

                  </div>
                  <!--左边耳机-->

                  <!--右边耳机-->
                  <div class="productmodelright"
                       @click='changeselectright()'>
                    <!--自定义上传-->
                    <div class="headsetcustommade">
                      <div class="custommade rightcustomize"
                           v-bind:style="{backgroundImage:'url('+CustomUplod.rightimg+')',      
                            width:CustomUplod.Rwidth + '%',
                            height:CustomUplod.Rheight + '%',
                            left:CustomUplod.Rleft + '%',
                            top:CustomUplod.Rtop + '%',
                            transform:'rotate('+CustomUplod.Rrotate+'deg) scale('+CustomUplod.Rscale+')'
                      }"></div>
                      <div class="headsetsmalllogo"></div>
                    </div>
                    <!--耳机线-->
                    <div class="headsetline" v-bind:style="{backgroundImage:'url(' + httpurl + SelectDesign.Wrightimg + ')'}"></div>
                    <!--耳机壳-->
                    <div class="headsetmold"
                         v-bind:style="{backgroundImage:'url(' + httpurl + SelectDesign.Kleftimg + ')'}"> </div>
                    <!--耳机壳加金箔粉-->
                    <div class="headsetgold"
                         v-bind:style="{backgroundImage:'url(' + httpurl + SelectDesign.KADDrightimg + ')'}"></div>
                    <!--耳机模-->
                    <div class="headsetcover"
                         v-bind:style="{backgroundImage:'url(' + httpurl + SelectDesign.leftimg + ')'}"></div>
                    <!--耳机模加金箔粉-->
                    <div class="headsetother"
                         v-bind:style="{backgroundImage:'url(' + httpurl + SelectDesign.addrightimg + ')'}">></div>
                    <!--耳机logo-->
                    <div class="headsetBiglogo"
                         v-bind:style="{backgroundImage:'url(' + httpurl + DesignMake.rightlogoimg + ')'}"></div>
                  </div>
                  <!--右边耳机-->
                </div>

                <div class="selectheadset"
                     rel="0">
                  <span class="scrollbar"
                        v-bind:style="'left:'+ changeselect + '%'"></span>
                  <dl>
                    <dd class="selectLeft"
                        @click='changeselectleft()'>Left</dd>
                    <dt class="selectPair"
                        @click='changeselectmiddle()'></dt>
                    <dd class="selectRight"
                        @click='changeselectright()'>Right</dd>
                  </dl>
                </div>
                <p class="design-fonts">木纹和钟表仅供参考，实际是不一样的，钟表面板上的logo(qdc)默认是刻在壳体上的.</p>
              </div>

              <div class="selectheadsettitle">
                <dl class="clearfl">
                  <h3>你的<span class="Pmodel">{{DesginList.Name}}</span></h3>
                  <dt style="width: 100%;">
                    <p><span class="w300">型号：<em class="Pmodel">{{DesginList.Name}}</em></span><span class="w130">￥<i class="modelprice Uniteprice">{{DesginList.Price|toFixed(2)}}</i></span></p>
                    <p><span class="w300">线材：<em class="PWire">{{SelectDesign.Wname}}</em></span><span class="w130">￥<i class="Wireprice Uniteprice">{{SelectDesign.Wprice|toFixed(2)}}</i></span></p>
                    <p><span class="w300">左耳面板：<em><i class="Pleftpanel">{{SelectDesign.Mleftname}}</i></em></span><span class="w130"
                            style="position: relative; top: 13px;">￥<i class="panelprice Uniteprice">{{SelectDesign.Mprice|toFixed(2)}}</i></span></p>
                    <p><span class="w300">右耳面板：<em><i class="Prightpanel">{{SelectDesign.Mrightname}}</i></em></span></p>
                    <p><span class="w300">左耳壳体：<em><i class="Pleftcase">{{SelectDesign.Kleftname}}</i></em></span><span class="w130"
                            style="position: relative; top: 13px;">￥<i class="caseprice Uniteprice">{{SelectDesign.Kprice|toFixed(2)}}</i></span></p>
                    <p><span class="w300">右耳壳体：<em><i class="Prightcase">{{SelectDesign.Krightname}}</i></em></span></p>
                    <p>
                      <span class="w300">面板（加金箔粉）：

                        <em v-if="SelectDesign.Maddleftnameid===4&&SelectDesign.Maddrightnameid===4">
                          <i class="panelleftplusgold">左</i>
                          <i class="panelrightplusgold">右</i>
                        </em>
                        <em v-if="SelectDesign.Maddleftnameid!==4&&SelectDesign.Maddrightnameid!==4">
                          <i class="panelleftplusgold">左{{SelectDesign.Maddleftname}}</i>
                          <i class="panelrightplusgold">右{{SelectDesign.Maddrightname}}</i>
                        </em>
                        <em v-if="SelectDesign.Maddleftnameid===4&&SelectDesign.Maddrightnameid!==4">
                          <i class="panelleftplusgold">左</i>
                          <i class="panelrightplusgold">右{{SelectDesign.Maddrightname}}</i>
                        </em>
                        <em v-if="SelectDesign.Maddleftnameid!==4&&SelectDesign.Maddrightnameid===4">
                          <i class="panelleftplusgold">左{{SelectDesign.Maddleftname}}</i>
                          <i class="panelrightplusgold">右</i>
                        </em>

                      </span>
                      <span class="w130">￥<i class="panelgoldprice Uniteprice">{{SelectDesign.Maddprice|toFixed(2)}}</i></span></p>
                    <p>
                      <span class="w300">壳体（加金箔粉）：
                        <em v-if="SelectDesign.Kaddleftnameid===7&&SelectDesign.Kaddrightnameid===7">
                          <i class="panelleftplusgold">左</i>
                          <i class="panelrightplusgold">右</i>
                        </em>
                        <em v-if="SelectDesign.Kaddleftnameid!==7&&SelectDesign.Kaddrightnameid!==7">
                          <i class="panelleftplusgold">左{{SelectDesign.Kaddleftname}}</i>
                          <i class="panelrightplusgold">右{{SelectDesign.Kaddrightname}}</i>
                        </em>
                        <em v-if="SelectDesign.Kaddleftnameid===7&&SelectDesign.Kaddrightnameid!==7">
                          <i class="panelleftplusgold">左</i>
                          <i class="panelrightplusgold">右{{SelectDesign.Kaddrightname}}</i>
                        </em>
                        <em v-if="SelectDesign.Kaddleftnameid!==7&&SelectDesign.Kaddrightnameid===7">
                          <i class="panelleftplusgold">左{{SelectDesign.Kaddleftname}}</i>
                          <i class="panelrightplusgold">右</i>
                        </em>

                      </span>
                      <span class="w130">￥<i class="casegoldprice Uniteprice">{{SelectDesign.Kaddprice|toFixed(2)}}</i></span></p>
                    <p>
                      <span class="w300">Logo样式：
                        <!-- <em v-if='logostylenumber==0'>
                          <i class="leftlogotitle">{{DesignMake.LogoStyleName}}（左）</i>
                          <i class="rightlogotitle">{{DesignMake.LogoStyleName}}（右）</i>
                        </em>
                        <em v-if='logostylenumber==1'>
                          <i class="leftlogotitle">{{DesignMake.LogoStyleName}}（左）</i>
                          <i class="rightlogotitle">{{DesignMake.LogoStyleName}}（右）</i>
                        </em> -->
                        <em>
                          <i class="leftlogotitle">{{DesignMake.LLogoStyleName}}（左）</i>
                          <i class="rightlogotitle">{{DesignMake.RLogoStyleName}}（右）</i>
                        </em>
                        <!-- <em v-if='RogoList.Llogostylenumber==1&&LogoList.Llogostylenumber==1'>
                          <i class="leftlogotitle">{{DesignMake.LogoStyleName}}（左）</i>
                          <i class="rightlogotitle">{{DesignMake.LogoStyleName}}（右）</i>
                        </em> -->
                      </span>
                    </p>
                    <p>
                      <span class="w300">Logo颜色：
                        <em>
                          <i class="leftlogoColour">{{DesignMake.LLogoColorName}}（左）</i>
                          <i class="rightlogoColour">{{DesignMake.RLogoColorName}}（右）</i>
                        </em>
                        <!-- <em v-if='logostylenumber==0&&logoColornumber==0'>
                          <i class="leftlogoColour">{{DesignMake.LogoColorName}}（左）</i>
                          <i class="rightlogoColour">{{DesignMake.LogoColorName}}（右）</i>
                        </em>
                        <em v-if='logostylenumber==0&&logoColornumber==1'>
                          <i class="leftlogoColour">{{DesignMake.LogoColorName}}（左）</i>
                          <i class="rightlogoColour">{{DesignMake.LogoColorName}}（右）</i>
                        </em>
                        <em v-if='logostylenumber==1&&logoColornumber==1'>
                          <i class="leftlogoColour">{{DesignMake.LogoColorName}}（左）</i>
                          <i class="rightlogoColour">{{DesignMake.LogoColorName}}（右）</i>
                        </em>
                        <em v-if='logostylenumber==1&&logoColornumber==0'>
                          <i class="leftlogoColour">{{DesignMake.LogoColorName}}（左）</i>
                          <i class="rightlogoColour">{{DesignMake.LogoColorName}}（右）</i>
                        </em> -->
                      </span>
                    </p>
                    <p>
                      <span class="w300">个性定制图案：

                        <em class="pattern"
                            v-show="CustomUplod.leftimg==''">无</em>
                        <em class="pattern"
                            v-show="CustomUplod.leftimg!=''">有</em>
                      </span>
                      <span class="w240" v-show="CustomUplod.leftimg!=''">￥
                        <i class="custommadeprice Uniteprice" >360</i>
                        此价格不是最终价格
                      </span>
                    </p>
                    <h4>耳机定制完成时间：<span>2-4周</span></h4>
                  </dt>
                </dl>
              </div>

              <div class="selectheadseTotalprice">
                  <span>总价格</span>￥
                  <i class="Colourprice" v-show="CustomUplod.leftimg==''">{{SelectDesign.SumPrice+parseFloat(this.logopriceLeft)+parseFloat(this.logopriceRight)|toFixed(2)}}</i>
                  <i class="Colourprice"  v-show="CustomUplod.leftimg!=''">{{SelectDesign.SumPrice+parseFloat(this.scprice)|toFixed(2)}}</i>
                 
              </div>

              <!--为了适应响应式 所以复制“上一步、下一步”结构-->
              <div class="modelselectNext m-modelselectNext">

                <a @click='back()'>上一步</a>
                <a class="cur"
                   @click='message()'>下一步</a>
              </div>

            </div>

          </div>

        </div>
      </div>

      <div class='popupbox'
           v-show='uploadLOGOVisable'>
        <h3>
          <em class='close'
              @click="uploadLOGOVisable = false"> </em>
          <span>提示</span>
        </h3>
        <p class='popupboxtext'>
          <span> 是否要删除默认Logo样式 ?</span>
          <br>
          为了更好地实现该功能，请选用谷歌浏览器；待上传的自定义个性图片需要用底色为透明的png格式图片
        </p>
        <p class='popupboxa'>
          <a class='deletelogostyle'
             @click='uploadEnter()'>确定</a>
          <a class='close'
             @click="uploadLOGOVisable = false">取消</a>
        </p>
      </div>

      <div class='popupbox'
           v-show='DelteuploadLOGOVisable'>
        <h3>
          <em class='close'
              @click="DelteuploadLOGOVisable = false"> </em>
          <span>提示</span>
        </h3>
        <p class='popupboxtext'>
          是否要删除自定义上传logo！
        </p>
        <p class='popupboxa'>
          <a class='deletelogostyle'
             @click='delteLogo()'>确定</a>
          <a class='close'
             @click="DelteuploadLOGOVisable = false">取消</a>
        </p>
      </div>

    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { getlogo,gettimg} from "@/api/api";
import myHeader from '@/views/designimg'
export default {
  components: { myHeader },
  data () {
    return {
      isshowlogocolor: false,
      showlogostyle: false,
      httpurl: 'http://shop.qdc.com/',
      change: {
        Lzy: 44.4167,
        Lsx: 50.134,
        Ldx: 1,
        Lxz: 0,
        Rzy: 44.4167,
        Rsx: 50.134,
        Rdx: 1,
        Rxz: 0      },
      UploadName: [{
        id: 1,
        name: '上传左边',      },
      {        id: 2,
        name: '上传右边'      }],


      CustomUplod: {
        // leftimg: require("../assets/REDIVG.png"),
        leftimg: '',
        rightimg: '',
        Lwidth: 20.5,
        Lheight: 19.7321,
        Lleft: 44.4167,
        Ltop: 50.134,
        Lrotate: 0,
        Lscale: 1,
        Rwidth: 20.5,
        Rheight: 19.7321,
        Rleft: 44.4167,
        Rtop: 50.134,
        Rrotate: 0,
        Rscale: 1
      },
      DelteuploadLOGOVisable: false,
      leftUploadVisable: false,
      rightUploadVisable: false,
      uploadLOGOVisable: false,
      MleftAvisable: false,
      Mleftvisable: true,
      MrightAvisable: false,
      Mrightvisable: true,
      LogoColorList1: [],
      LogoColorList2: [],
      LogoList: [],
      //   DesignList: {},

      DesignMake: {
        //             Llogostylenumber:0,
        // Rlogostylenumber:0,
        // LlogoColornumber:-1,
        // RlogoColornumber:-1,
        //   LogoColorName: '',
        //   LogoStyleName: '',
        LLogoColorNameid: '',
        RLogoColorNameid: '',
        LLogoColorName: '',
        RLogoColorName: '',
        LLogoStyleName: '',
        RLogoStyleName: '',
        LLogoStyleNameid: '',
        RLogoStyleNameid: '',
        SumPrice: 0,
        leftlogoimg: '',
        rightlogoimg: '',
        //leftlogoimg:require("../assets/2016090616100245.png"),
        //						rightlogoimg: require("../assets/2016090616100017.png"),
        //						addleftimg: require("../assets/leftjfkt.png"),
        //						addrightimg: require("../assets/rightjfkt.png"),
      },
      PanelOtherColornumber: 3,
      PanelOtherShellColornumber: 2,
      ShellColorVisible: true,
      PanelColorVisible: true,
      PanelMaterialVisible: true,
      selectWire: false,
      SelectDesign: {
        LogoColorName: "",
        LogoStyleName: "",
        SumPrice: 0,
        leftlogoimg: "",
        rightlogoimg: "",
        leftlogoimg: "",
        rightlogoimg: "",
        addleftimg: "",
        addrightimg: "",
        leftimg: "",
        rightimg: "",
        SumPrice: 0,
        PanelOtherid: 4,

        addleftimg: "",
        addrightimg: "",
        //						addleftimg: require("../assets/leftjfkt.png"),
        //						addrightimg: require("../assets/rightjfkt.png"),
        Kleftimg: "",
        Krightimg: "",
        KADDleftimg: "",
        KADDrightimg: "",
        Mleftname: "",
        Mrightname: "",
        Mprice: 0,
        Kaddleftname: "",
        Kaddrightname: "",
        Kaddleftnameid: 3,
        Kaddrightnameid: 3,
        Kaddprice: 0,
        Maddleftname: "",
        Maddrightname: "",
        Maddleftnameid: 4,
        Maddrightnameid: 4,
        Maddprice: 0,
        Kleftname: "",
        Krightname: "",
        Kprice: 0,
        Wname: "",
        Wprice: 0
      },
      PanelOtherShellid: -1,

      logostylenumber: 0,
      logoColornumber: -1,
      changeselect: 45,
      UploadNameID: -1,
      scprice:360,
      logopriceLeft:0,
      logopriceRight:0,
    }
  },
  created () {

    this.getlogoList();
    if (localStorage.getItem("newDesginList") != null || localStorage.getItem("newDesginList") != undefined) {
      var list = JSON.parse(localStorage.getItem('newDesginList'));
      this.DesginList = list

    } else {
      this.DesginList = {}
      this.$message({
        message: "您暂未选择设计型号，我们将帮你返回让你进行选择",
        type: 'error'
      });
      this.$router.push('/Design')
    }

    if (localStorage.getItem("newSelectDesign") != null || localStorage.getItem("newSelectDesign") != undefined) {
      var SelectDesign = JSON.parse(localStorage.getItem('newSelectDesign'));
      this.SelectDesign = SelectDesign

    } else {
      this.SelectDesign.Kleftimg = 'uploads/admin/image/20160902/2016090210273171.png'
      this.SelectDesign.Krightimg = 'uploads/admin/image/20160902/2016090210272948.png'
      this.SelectDesign.leftimg = 'uploads/admin/image/20160902/2016090209324618.png'
      this.SelectDesign.rightimg = 'uploads/admin/image/20160902/2016090209324285.png'
    }
    if (localStorage.getItem("newDesignMake") != null || localStorage.getItem("newDesignMake") != undefined) {
      var DesignMake = JSON.parse(localStorage.getItem('newDesignMake'));
      this.DesignMake = DesignMake
    }
    if (localStorage.getItem("newCustomUplod") != null || localStorage.getItem("newCustomUplod") != undefined) {
      var CustomUplod = JSON.parse(localStorage.getItem('newCustomUplod'));
      this.CustomUplod = CustomUplod
    }




  },
  computed: {

    //    this.SelectDesign.SumPrice=parseFloat(list.Price)+parseFloat(list.Wprice)+parseFloat(list.Mprice)
    // +parseFloat(list.Maddprice)+parseFloat(list.Kprice)+parseFloat(list.Kaddprice);
    // list.SumPrice= parseFloat(list.Price)+parseFloat(list.Wprice)+
    // parseFloat(list.Mprice)+parseFloat(list.Maddprice)+parseFloat(list.Kprice)+parseFloat(list.Kaddprice);
  },


  methods: {
    //LOGO样式
    getlogoList () {
      var para = {};

      getlogo(para).then(res => {
        this.isshowlogocolor = true,
          // console.log("LOGO请求成功", res.data);
          this.LogoList = res.data.style,
          //   this.SelectDesign.leftimg = res.data.List[1].list[7].leftimg,
          //   this.SelectDesign.rightimg = res.data.List[1].list[7].rightimg,
          res => {
            console.info("调用失败", res);
          };
      });
    },

    changeleft () {
   
      this.CustomUplod.Lleft = this.change.Lzy;
      this.CustomUplod.Ltop = this.change.Lsx;
      this.CustomUplod.Lscale = this.change.Ldx;
      this.CustomUplod.Lrotate = this.change.Lxz;
    },
    changeright () {
     
      this.CustomUplod.Rleft = this.change.Rzy;
      this.CustomUplod.Rtop = this.change.Rsx;
      this.CustomUplod.Rscale = this.change.Rdx;
      this.CustomUplod.Rrotate = this.change.Rxz;
    },
    uploadLOGO (id) {
        // console.log('id:::'+id)
      this.UploadNameID = id;
      if (this.DesignMake.LogoColorName == '' && this.DesignMake.LogoStyleName == '') {
        this.uploadLOGOVisable = !this.uploadLOGOVisable;
      }
      if (this.DesignMake.LogoColorName != '' && this.DesignMake.LogoStyleName != '') {
        this.DelteuploadLOGOVisable = !this.DelteuploadLOGOVisable
      }

    },
    uploadEnter () {
      this.uploadLOGOVisable = !this.uploadLOGOVisable;
      if (this.UploadNameID == 1) {
        this.leftUploadVisable = true;
        this.DesignMake.leftlogoimg = '';
         this.DesignMake.LogoColorName = '';
        this.DesignMake.LogoStyleName = '';
      }
      if (this.UploadNameID == 2) {
        this.rightUploadVisable = true;
         this.DesignMake.rightlogoimg = '';
          this.DesignMake.LogoColorName = '';
        this.DesignMake.LogoStyleName = '';
      }

      this.$refs.fileInput.click()

    },
    delteLogo () {
      if (this.CustomUplod.leftimg != '') {
         this.DesignMake.leftlogoimg = '';
         this.DesignMake.LogoColorName = '';
        this.DesignMake.LogoStyleName = '';
      }
      if(this.CustomUplod.rightimg != ''){
          this.DesignMake.rightlogoimg = '';
            this.DesignMake.LogoColorName = '';
        this.DesignMake.LogoStyleName = '';
      }
      if (this.CustomUplod.leftimg == ''||this.CustomUplod.rightimg == '') {
        this.DesignMake.rightlogoimg = '';
        this.DesignMake.leftlogoimg = '';
        this.DesignMake.LogoColorName = '';
        this.DesignMake.LogoStyleName = '';
      }
      this.DelteuploadLOGOVisable = !this.DelteuploadLOGOVisable
    },
    getFile (event) {
      const files = event.target.files
      let filename = files[0].name          //只有一个文件
      if (filename.lastIndexOf('.') <= 0) {
        return alert("Please add a valid image!")        //判断图片是否有效
      }
      const fileReader = new FileReader()                //内置方法new FileReader()   读取文件
      fileReader.addEventListener('load', () => {
        //   this.CustomUplod.leftimg = fileReader.result
        if (this.UploadNameID == 1) {
          this.CustomUplod.leftimg = fileReader.result
          this.logopriceLeft=0
        }
        if (this.UploadNameID == 2) {
          this.CustomUplod.rightimg = fileReader.result
          this.logopriceRight=0
        }

      })
      fileReader.readAsDataURL(files[0])
      this.image = files[0]

      //到这里后, 选择图片就可以显示出来了
    },
    handlelogoColor (index, item) {
      
      this.logoColornumber = index;

      if (item.id) {
        if (this.changeselect == 45) {
          this.DesignMake.LLogoColorNameid = item.id;
          this.DesignMake.RLogoColorNameid = item.id;
          this.DesignMake.LLogoColorName = item.name;
          this.DesignMake.RLogoColorName = item.name;
          this.DesignMake.leftlogoimg = item.leftlogoimg;
          this.DesignMake.rightlogoimg = item.rightlogoimg;
          this.CustomUplod.leftimg=''
          this.CustomUplod.rightimg=''
          this.logopriceLeft=item.price
          this.logopriceRight=item.price         
        }
        if (this.changeselect == 1) {
          this.DesignMake.LLogoColorNameid = item.id;
          this.DesignMake.LLogoColorName = item.name;
          this.DesignMake.leftlogoimg = item.leftlogoimg;
            this.CustomUplod.leftimg=''
             this.logopriceLeft=item.price
        }
        if (this.changeselect == 90) {
          this.DesignMake.RLogoColorNameid = item.id;
          this.DesignMake.RLogoColorName = item.name;
          this.DesignMake.rightlogoimg = item.rightlogoimg;
          this.CustomUplod.rightimg=''
          this.logopriceRight=item.price   
        }
      }

      // this.DesignMake.LogoColorName = item.name;

      //   this.DesignMake.leftlogoimg = item.leftlogoimg;
      //   this.DesignMake.rightlogoimg = item.rightlogoimg;


    },
    handlelogostyle (index, item) {
      //   if (this.CustomUplod.leftimg != '') {
      //     this.DelteuploadLOGOVisable = !this.DelteuploadLOGOVisable
      //   }
    //   console.log('handlelogostyle')
    //   console.log('this.CustomUplod.leftimg'+this.changeselect)

//      if(this.CustomUplod.rightimg!=''){
//  this.CustomUplod.rightimg=''
//      }
console.log('logo选择：'+index)
      
//           if(this.CustomUplod.leftimg==''&&this.DesignMake.leftlogoimg==''){
//  this.DesignMake.leftlogoimg = item.list[0].leftlogoimg;
//           }
//             if(this.CustomUplod.rightimg==''&&this.DesignMake.rightlogoimg==''){
//           this.DesignMake.rightlogoimg = item.list[0].rightlogoimg;
//           } 
     
      this.logostylenumber = index;
    
           this.DesignMake.LLogoColorNameid =item.list[0].id
          this.DesignMake.RLogoColorNameid = item.list[0].id
           this.DesignMake.LLogoColorName = item.list[0].name;
          this.DesignMake.RLogoColorName = item.list[0].name;
          this.logoColornumber = 0
        
   
      if (item.id) {
        if (this.changeselect == 45) {
          this.DesignMake.LLogoStyleNameid = item.id
          this.DesignMake.RLogoStyleNameid = item.id
        //   this.DesignMake.leftlogoimg = item.leftlogoimg;
        //   this.DesignMake.rightlogoimg = item.rightlogoimg;
          this.DesignMake.LLogoStyleName = item.name;
          this.DesignMake.RLogoStyleName = item.name;
          this.DesignMake.leftlogoimg = item.list[0].leftlogoimg;
          this.DesignMake.rightlogoimg = item.list[0].rightlogoimg;
          
        }
        if (this.changeselect == 1) {
            this.CustomUplod.leftimg=''
           this.DesignMake.leftlogoimg = item.list[0].leftlogoimg;
          this.DesignMake.LLogoStyleNameid = item.id
        //   this.DesignMake.leftlogoimg = item.leftlogoimg;
          this.DesignMake.LLogoStyleName = item.name;
        }
      }
      if (this.changeselect == 90) {
          this.CustomUplod.rightimg=''
           this.DesignMake.rightlogoimg = item.list[0].rightlogoimg;
        this.DesignMake.RLogoStyleNameid = item.id
        // this.DesignMake.rightlogoimg = item.rightlogoimg;
        this.DesignMake.RLogoStyleName = item.name;
      }

      // console.log( this.logostylenumber )

      //    this.showlogostyle=!this.showlogostyle;
      //   this.DesignMake.leftlogoimg = item.leftlogoimg;
      //   this.DesignMake.rightlogoimg = item.rightlogoimg;
      //   this.DesignMake.LogoStyleName = item.name;
    },
    back () {
      this.$router.push('/DesignColor')
    },
    message () {
        var logoSumPrice=parseFloat(this.logopriceRight)+parseFloat(this.logopriceLeft)
        // console.log('logo总价:'+logoSumPrice)
        if(this.CustomUplod.leftimg!=''){
  this.DesignMake.SumPrice = this.SelectDesign.SumPrice+parseFloat(this.scprice)+logoSumPrice
        }else{
              this.DesignMake.SumPrice = this.SelectDesign.SumPrice+logoSumPrice
        }
       
     var self = this;
      var para = {               
        Cleftimg: this.CustomUplod.leftimg,
        Crightimg: this.CustomUplod.rightimg,
      };
  

      gettimg(para).then(res => {
    localStorage.setItem('imglist',JSON.stringify(res.data) )
        res => {
          console.info("调用失败", res);
        };
        
      });
      
      this.$router.push({ path: '/DesignMessage' })
      this.$store.dispatch('ChangeCustomUplod', this.CustomUplod)
      this.$store.dispatch('Changelogostylenumber', this.logostylenumber)
      this.$store.dispatch('ChangelogoColornumber', this.logoColornumber)
      this.$store.dispatch('ChangeDesignMake', this.DesignMake)
     
    },

    changeselectleft () {
      this.changeselect = 1;
    //   console.log(this.changeselect)
    },
    changeselectright () {
      this.changeselect = 90
    },
    changeselectmiddle () {
      this.changeselect = 45
    },
    Update (item) {
      if (item.pkid) {
        this.Description = item.content
        this.Name = item.name
        this.Price = item.price
      }
    }
  },
}
</script>

<style scoped>
@import "../../static/newlayout.css";
@import "../../static/global.css";
.sliderstyle {
  /* margin-top: -2px; */
  float: left;
  /* padding: 7px 0px; */
  width: 165px;
  height: 6px;
  /* background: #9499a0 !important; */
}
/* .vue-slider-rail /deep/.vue-slider-process {
  background-color: #9499a0 !important;
  border-radius: 15px;
}
.vue-slider-rail /deep/.vue-slider-rail {
  background-color: #9499a0 !important;
  border-radius: 15px;
} */
/* .vue-slider-rail /deep/.vue-slider-dot-handle {
  cursor: pointer;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  box-sizing: border-box;
  box-shadow: 0.5px 0.5px 2px 1px rgba(0, 0, 0, 0.32);
} */
.vue-slider /deep/.vue-slider-ltr {
  padding: 0 !important;
  width: auto !important;
  height: 6px !important;
}
</style>


// WEBPACK FOOTER //
// src/views/DesignMake.vue